import type { DeepValue } from '@tanstack/react-form'
import { Label } from '@neo/primitives/label'
import type { GenericFieldConfig, GenericFormType } from '@neo/blocks/forms/types'
import type { MultiPartyCallOutboundNodeData, SidebarComponentProps } from '../types'
import { v2validations } from '../config/validation.config'
import { GenericSidebarComponent } from './sidebar.base'
import { AudioUploadCore } from '../components/audio-prompt/audio-upload-core'

type FormValues = MultiPartyCallOutboundNodeData['config']

const fields = (nodeVars: string[]): GenericFieldConfig<FormValues> => {
  const validations = v2validations({ nodeVars }).multi_party_call_outbound
  return [
    {
      name: 'name',
      label: 'Name',
      zodValidation: validations.shape.name,
      componentType: 'input',
    },
    {
      name: 'agent_hold_music',
      label: 'Agent hold music',
      type: 'custom',
      zodValidation: validations.shape.agent_hold_music,
      eventDataExtractor: (data: Record<string, unknown>) => data,
      component: ({
        value,
        onChange,
      }: {
        value: DeepValue<FormValues, 'agent_hold_music'>
        onChange: (value: Record<string, unknown>) => void
        label: string
        form: GenericFormType<FormValues>
      }) => {
        const v = value
        const onUrlChange = (url: string) => {
          if (!v) return onChange({ url })
          onChange({
            ...v,
            url,
          })
        }
        return (
          <>
            <Label className="mb-1.5 block">Agent hold music</Label>
            <AudioUploadCore url={v?.url ?? ''} onURLChange={onUrlChange} />
          </>
        )
      },
      className: 'mb-2',
    },
    {
      name: 'customer_hold_music',
      label: 'Custom hold music',
      type: 'custom',
      zodValidation: validations.shape.customer_hold_music,
      eventDataExtractor: (data: Record<string, unknown>) => data,
      component: ({
        value,
        onChange,
      }: {
        value: DeepValue<FormValues, 'customer_hold_music'>
        onChange: (value: Record<string, unknown>) => void
        label: string
        form: GenericFormType<FormValues>
      }) => {
        const v = value
        const onUrlChange = (url: string) => {
          if (!v) return onChange({ url })
          onChange({
            ...v,
            url,
          })
        }
        return (
          <>
            <Label className="mb-1.5 block">Customer hold music</Label>
            <AudioUploadCore url={v?.url ?? ''} onURLChange={onUrlChange} />
          </>
        )
      },
      className: 'mb-2',
    },
  ]
}

// NODE_GEN: Update this code, do not commit directly
// Remove this comment after updating the code

export const MultiPartyCallOutboundSidebarComponent = (
  props: SidebarComponentProps<MultiPartyCallOutboundNodeData>,
) => {
  const { nodeVars } = props
  const formFields = fields(nodeVars)

  return <GenericSidebarComponent fields={formFields} {...props} />
}
